import 'url-search-params-polyfill';
import 'moment/locale/ru';

import './App.pcss';

import React, { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import focusWithin from 'focus-within';

import { PortalProvider } from '@mos-cat/portal';

import AppRoutes from './AppRoutes';
import defaultBreadcrumbs from './config/breadcrumbs';
import aboutContent from './config/aboutContent';
import ServiceHeader from './components/ServiceHeader/ServiceHeader';
import BreadcrumbsContext from './components/BreadcrumbsContext';

import configureStore from './store';
import ACSBroadcast from './helpers/ACSBroadcast';

focusWithin(document, { force: true });

const store = configureStore();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
  });
}

const App = () => {
  const [isHomeRoute, setHomeRoute] = useState(
    window.location.pathname ===
      '/services/podat-apellyatsiyu-na-rezultaty-gia/',
  );
  const [endCrumbs, setEndCrumbs] = useState([]);
  let breadcrumbs = [...defaultBreadcrumbs];

  useEffect(() => {
    ACSBroadcast.init();
  }, []);

  if (endCrumbs.length) {
    breadcrumbs.splice(-endCrumbs.length, endCrumbs.length, ...endCrumbs);
  }

  breadcrumbs = isHomeRoute
    ? breadcrumbs.filter((item) => !item.notForHome)
    : breadcrumbs;

  return (
    <Sentry.ErrorBoundary fallback="An error has occured">
      <Provider store={store}>
        <PortalProvider>
          <BreadcrumbsContext.Provider value={{ endCrumbs, setEndCrumbs }}>
            <div className="App">
              <ServiceHeader
                breadcrumbs={breadcrumbs}
                aboutServiceData={{
                  titleToggle: 'Об услуге',
                  titleWindow: 'Об услуге',
                  titleCloseBtn: 'Скрыть',
                  content: aboutContent,
                }}
              />
              <AppRoutes setHomeRoute={setHomeRoute} />
            </div>
          </BreadcrumbsContext.Provider>
        </PortalProvider>
      </Provider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
